import { AddCarrierToWorkspace } from './add-carrier-to-workspace'

/**
 * This component is used to render the drawers at the layout level.
 * It is used to ensure that only one instance of the drawers is created.
 * And used across multiple components.
 */
export const DrawersContainer = () => {
  return <AddCarrierToWorkspace />
}
